

































































import {Component, Vue} from 'vue-property-decorator';
import {Drag, Drop} from 'vue-drag-drop';
import {SDynamicComponent} from '@/components/dto/SDynamicComponent';
import DynamicComponents from '@/components/DynamicComponents.vue';
import Tree from '@/components/Tree.vue';
import {STreeData} from '@/components/dto/STreeData';
import {TreeUtils} from '@/components/utils/TreeUtils';
import {ObjUtils} from '@/components/utils/ObjUtils';
import DropComponents from '@/components/DropComponents.vue';
import {ScomponentMode} from '@/components/dto/ScomponentMode';
import {ScomponentModeImpl} from '@/components/dto/ScomponentModeImpl';
import CollapseComponentList from '@/components/CollapseComponentList.vue';
import {SComponents} from '@/components/dto/SComponents';
import {EComponentTypes} from '@/components/enum/EComponentTypes';
import {SComponentsGroup} from '@/components/dto/SComponentsGroup';
import {SAddComponentFormValueImpl, SAddComponentImpl} from '@/components/dto/SAddComponentFormValueImpl';
import AddComponents from '@/views/administration/AddComponents.vue';
import {SAddComponentFormValue} from '@/components/dto/SAddComponentFormValue';
import {UidGenerate} from '@/components/utils/UidGenerate';
import ComponentSource from '@/components/ComponentSource.vue';
import { SPropTypeEnum } from '@/components/dto/SPropTypeEnum';


@Component({
    components: {ComponentSource, AddComponents, CollapseComponentList, DropComponents, Drag, Drop, DynamicComponents, Tree}
})
export default class PageModeler extends Vue {
    private components: SComponentsGroup[] = [];
    private componentsModuls: SComponentsGroup[] = [];
    private componentsCustom: SComponentsGroup[] = [];
    private schema: SDynamicComponent[] = [];
    private data: Object = {};
    private modalTitle: String = "";
    private showModal: Boolean = false;
    private showModalAddComponent: boolean = false;
    private modalInputPlainText: boolean = false;
    private trees : STreeData = {type:SPropTypeEnum.SNULL,  treeItems: []};
    private componentModalSetting: SDynamicComponent = {component:{uid: "", name:"", url:""}, data:{}, componentMode: {editable:true,delete:true,addHint:true, moveComponent:true}};
    private over: boolean = false;
    private dropItem: SDynamicComponent[] = [];
    private mode: ScomponentMode = new ScomponentModeImpl(true,true,true,true);
    private addCustomComponentData: SAddComponentFormValue = SAddComponentFormValueImpl.prototype.empty();

    constructor(){
        super();
        this.componentGroups();
    }

    componentGroups(): void {
        this.$store.dispatch('loadComponentGroups').then(() => {
            this.components = this.loadComponents({component_type: EComponentTypes[EComponentTypes.basic], component_group: null});
            this.componentsModuls = this.loadComponents({component_type: EComponentTypes[EComponentTypes.modul], component_group: null});
            this.componentsCustom = this.loadComponents({component_type: EComponentTypes[EComponentTypes.custom], component_group: null});
        });
    }

    loadComponents(searchCriteria: Object): SComponentsGroup[]{
        let componentsGroups: SComponentsGroup[] = [];
            this.$store.dispatch('loadComponents', searchCriteria).then(() => {
                for (let group of this.$store.getters.componentGroups) {
                    let itemsGroup: SComponents[] = this.$store.getters.components.filter((item: SComponents) => item.component_group === group.name);
                    if (itemsGroup.length > 0) {
                        let groupItem = {
                            name: group.name,
                            components: itemsGroup,
                            visible: false
                        };
                        componentsGroups.push(groupItem);
                    }
                }
                return componentsGroups;
            }).catch(err => {
                console.log(err);
            });
        return componentsGroups;
    }

    openComponentSettings(item: SDynamicComponent):void{
        this.componentModalSetting = item;
        this.modalTitle = item.component.name;
        this.trees.treeItems = TreeUtils.createTreeItem(item.data);
        this.showModal = true;
    }

    removeComponent(uid: string):void{
        ObjUtils.removeComponent(this.schema, uid);
    }

    updateComponentProperty():void{
        this.trees.treeItems.forEach( item => {
            let property;
            if(typeof item.propValue === 'boolean'){
                property = item.propValue;
            }else if(typeof item.propValue === 'string'){
                property = item.propValue;
            }else if(typeof item.propValue === 'number'){
                property = isNaN(item.propValue)? item.propValue: Number(item.propValue)
            }else {
                property = item.propValue;
            }
            this.componentModalSetting.data[item.propName] = property;
        })
    }

    addCustomComponent():void{
        this.showModalAddComponent = true;
    }

    saveCustomComponent(){
        this.addCustomComponentData.version.value = '0.1';
        this.addCustomComponentData.component_type.value = EComponentTypes[EComponentTypes.custom];
        this.addCustomComponentData.component_group.value = 'alert';
        this.addCustomComponentData.component.value = JSON.stringify(this.schema);
        let add = new SAddComponentImpl(this.addCustomComponentData);
        this.$store.dispatch('addcomponent', add).then(() => {
            //return this.data = SAddComponentFormValueImpl.prototype.empty();
        }).catch(err => {
            console.log(err);
        });
    }

    handleDragstart(startData: any, event: any):void{
        this.dropItem = [];
        let item = ObjUtils.deepCopy(startData.item.component);
        if(typeof item === 'string'){
            let addSchema: SDynamicComponent[] = ObjUtils.parseJsonString(item);
            this.dropItem.push(...addSchema);
        }else{
            item.component.uid = UidGenerate.gen();
            this.dropItem.push(item);
        }
        event.stopPropagation();
    }


    handleDrop(uid: string):void {
        if(uid !== 'root'){
            ObjUtils.pushComponent(this.schema, uid, this.dropItem);
        }else {
            this.schema.push(...this.dropItem);
        }
        this.over = false;
    }
    handle_function_call(e: any, param: any):void {
        if(Array.isArray(param)){
          // @ts-ignore
          this[e].apply(this, param);
        } else {
          // @ts-ignore
          this[e](param);
        }
    }
}
